module.exports = __webpack_public_path__ + "img/calender.6f749a7a.svg";